import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      margin: '0',
      color: palette.text.white,
      fontWeight: 600,
      marginTop: '5px',
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100%',
      justifyContent: 'space-between',
      gap: '10px',
      padding: '0 10px 10px 10px'
    },
    large: {
      fontSize: '2rem',
      fontWeight: 700
    },
    bold: {
      fontWeight: 700
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
